<template>
  <div>
    <breadcrumb/>
    <moments-list></moments-list>
  </div>
</template>

<script>
import MomentsList from "@/components/Posts/MomentsList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    MomentsList,
    Breadcrumb
  },
  mounted(){
    // Manda el scroll al inicio cada vez que se cambia de ruta
    window.scrollTo(0, 0);
  },
};
</script>